<template>
  <div class="container-fluid">
    <div class="modal fade" id='registerModal' data-backdrop=false
         tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true"
         data-keyboard="false">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content bg-light">
          <div class="modal-header">
            <h5 class="modal-title" id="staticBackdropLabel">Créer mon compte Bimedia</h5>
          </div>
          <div class="modal-body bg-white text-dark">
            <p>Merci de choisir un identifiant et un mot de passe afin de créer votre compte
              Bimedia associé au mail <b>{{email}}</b></p>
            <RegisterForm :email="email"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import RegisterForm from '../components/form/RegisterForm.vue';

export default {
  name: 'Register',
  data() {
    return {
      // Token de vérification
      token: this.$route.query.token,
      email: this.$route.query.mail,
      source: undefined,
    };
  },
  created() {
    axios.post('/auth/api/front/token', JSON.stringify({
      token: this.token,
    }), { headers: { 'content-type': 'application/json' } })
      .then((res) => {
        $(document).ready(() => {
          this.source = res.data.source;
          $('#registerModal').modal('show');
        });
      })
      .catch(() => {
        this.$router.push({ name: 'Error', params: { errorType: 'token' } });
      });
  },
  components: {
    RegisterForm,
  },
};
</script>
